window.addEventListener('load', () => {

    const burgerTrigger = document.getElementById('menuToggle');

    if (!burgerTrigger) return;

    burgerTrigger.addEventListener('click', e => {
        e.preventDefault()
        document.body.classList.toggle('nav-open')
    });

});

